import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';

import { Thread } from '../../tamalelibs/models/thread.model';
import { SortInfo } from '../../pages/research/research.view-model';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../redux';
import { lastCustomActionSelector } from '../../redux/reducers/action-history.reducer';
import { DELETE_ATTACHMENT_SUCCESS, DELETE_SIDENOTE_SUCCESS } from '../../tamalelibs/redux/note.actions';

@Component({
    selector: 'draft-list-item',
    templateUrl: './draft-list-item.component.html',
    styleUrls: ['./draft-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DraftListItemComponent implements OnInit, OnDestroy {
    @Input() thread: Thread;
    @Input() sortInfo: SortInfo;
    entitiesInString: string;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _store: Store<AppState>,
        private _changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        this.entitiesInString = this.thread.entities.map(item => item.shortName).join(', ');
        this._destroySubscriptions.push(
            this._store.pipe(
                select(lastCustomActionSelector)
            ).subscribe(action => this._actionMessageHandler(action)),
        );
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    trackByFn(index, item) {
        return item.id;
    }

    private _actionMessageHandler(action) {
        if (action.type === DELETE_ATTACHMENT_SUCCESS || action.type === DELETE_SIDENOTE_SUCCESS) {
            setTimeout(() => {
                if (!this._changeDetectorRef['destroyed']) {
                    this._changeDetectorRef.detectChanges();
                }
            });
        }
    }

}
